module.exports = __webpack_public_path__ + "static/media/vender-2.b6b243d7.svg";